module.exports = __webpack_public_path__ + "d9ef1dd735d67d4561857aef6dfcdcff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_90.jpg
// module id = 1758
// module chunks = 5